(function () {
  var finderSelector = '[data-excel-location-finder]';
  var branchSelector = '[data-excel-location-branch]';
  var zipCache = new Map();

  function radians(degrees) {
    return degrees * Math.PI / 180;
  }

  function distanceInMiles(latitude, longitude, branch) {
    var destinationLatitude = Number(branch.dataset.locationLat);
    var destinationLongitude = Number(branch.dataset.locationLng);
    var latitudeDelta = radians(destinationLatitude - latitude);
    var longitudeDelta = radians(destinationLongitude - longitude);
    var haversine = Math.sin(latitudeDelta / 2) ** 2
      + Math.cos(radians(latitude)) * Math.cos(radians(destinationLatitude)) * Math.sin(longitudeDelta / 2) ** 2;
    return 3958.8 * 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(Math.max(0, 1 - haversine)));
  }

  function message(finder, key, replacements) {
    var result = finder.getAttribute('data-message-' + key) || '';
    Object.keys(replacements || {}).forEach(function (name) {
      result = result.replace('[' + name + ']', replacements[name]);
    });
    return result;
  }

  function feedback(finder, text) {
    finder.querySelector('[data-excel-location-feedback]').textContent = text;
  }

  function showBranches(finder, zip, latitude, longitude) {
    var list = finder.querySelector('[data-excel-location-list]');
    var branches = Array.from(list.querySelectorAll(branchSelector));
    branches.forEach(function (branch) {
      var distance = distanceInMiles(latitude, longitude, branch);
      branch.dataset.locationDistance = String(distance);
      branch.removeAttribute('data-location-nearest');
      var label = branch.querySelector('[data-excel-location-distance]');
      label.textContent = message(finder, 'distance', { miles: distance.toFixed(1) });
      label.hidden = false;
    });
    branches.sort(function (first, second) {
      var firstSoon = first.hasAttribute('data-location-opening-soon');
      var secondSoon = second.hasAttribute('data-location-opening-soon');
      if (firstSoon !== secondSoon) return Number(firstSoon) - Number(secondSoon);
      return Number(first.dataset.locationDistance) - Number(second.dataset.locationDistance);
    });
    branches.forEach(function (branch) { list.appendChild(branch); });
    branches[0].setAttribute('data-location-nearest', '');
    feedback(finder, message(finder, 'result', { zip: zip, branch: branches[0].dataset.locationName }));
  }

  function bindSearch(finder) {
    var form = finder.querySelector('[data-excel-location-search]');
    var input = finder.querySelector('[data-excel-location-query]');
    var button = form.querySelector('button');
    var list = finder.querySelector('[data-excel-location-list]');
    var originalBranches = Array.from(list.querySelectorAll(branchSelector));
    var lastInputValue = input.value;
    var requestController;
    var requestNumber = 0;

    function resetSearch() {
      if (input.value === lastInputValue) return;
      lastInputValue = input.value;
      requestNumber += 1;
      if (requestController) requestController.abort();
      input.removeAttribute('aria-invalid');
      button.disabled = false;
      form.removeAttribute('aria-busy');
      feedback(finder, '');
      if (!list.querySelector('[data-location-nearest]')) return;
      originalBranches.forEach(function (branch) {
        branch.removeAttribute('data-location-nearest');
        branch.removeAttribute('data-location-distance');
        var label = branch.querySelector('[data-excel-location-distance]');
        label.hidden = true;
        label.textContent = '';
        list.appendChild(branch);
      });
    }

    input.addEventListener('input', resetSearch);
    input.addEventListener('change', resetSearch);

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      event.stopPropagation();
      resetSearch();
      if (requestController) requestController.abort();
      button.disabled = false;
      form.removeAttribute('aria-busy');
      var currentRequest = ++requestNumber;
      var value = input.value.trim();
      if (!/^\d{5}(-\d{4})?$/.test(value)) {
        input.setAttribute('aria-invalid', 'true');
        feedback(finder, message(finder, 'invalid'));
        input.focus();
        return;
      }
      var zip = value.slice(0, 5);
      input.removeAttribute('aria-invalid');
      if (zipCache.has(zip)) {
        var cached = zipCache.get(zip);
        showBranches(finder, zip, cached.latitude, cached.longitude);
        return;
      }
      requestController = new AbortController();
      var controller = requestController;
      var timeout = window.setTimeout(function () { controller.abort(); }, 8000);
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      feedback(finder, message(finder, 'loading'));
      try {
        var response = await fetch('https://api.zippopotam.us/us/' + zip, { signal: controller.signal, credentials: 'omit' });
        if (currentRequest !== requestNumber) return;
        if (response.status === 404) {
          input.setAttribute('aria-invalid', 'true');
          feedback(finder, message(finder, 'no-match'));
          return;
        }
        if (!response.ok) throw new Error('Postal lookup failed');
        var data = await response.json();
        if (currentRequest !== requestNumber) return;
        var place = data.places && data.places[0];
        var latitude = Number(place && place.latitude);
        var longitude = Number(place && place.longitude);
        if (!place || !Number.isFinite(latitude) || !Number.isFinite(longitude)) throw new Error('Invalid postal coordinates');
        zipCache.set(zip, { latitude: latitude, longitude: longitude });
        showBranches(finder, zip, latitude, longitude);
      } catch (error) {
        if (currentRequest === requestNumber) feedback(finder, message(finder, 'error'));
      } finally {
        window.clearTimeout(timeout);
        if (currentRequest === requestNumber) {
          button.disabled = false;
          form.removeAttribute('aria-busy');
        }
      }
    }, true);

  }

  function initialiseAll() {
    document.querySelectorAll(finderSelector).forEach(function (finder) {
      if (finder.dataset.excelLocationFinderBound === 'true') return;
      finder.dataset.excelLocationFinderBound = 'true';
      bindSearch(finder);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll);
  } else {
    initialiseAll();
  }
  document.addEventListener('shopify:section:load', initialiseAll);
}());
